import React from 'react';
import StartLaunch from './startLaunch';
import StartCount from './startCount';
import StartProgress from './startProgress';
import StartFinished from './startFinished';
import StartGetStarted from './startGetStarted';
import StartCreateAccount from './startCreateAccount';
import VirtualProgress from './virtualProgress';
// import Affyn from './furthur_pages/affyn';
// import Affyndetails from './furthur_pages/affyndetails';

export default function Virtual_Start() {
  return (
    <div style={{color:'#fff'}}>
      <StartLaunch />
      <StartCount />
      <VirtualProgress />
      {/* <StartProgress /> */}
      <StartFinished />
      <StartGetStarted />
      <StartCreateAccount />
    </div>
  )
}